import React from 'react'
import cls from '@UI/crypto_exchange/desktop/components/modals/ProblemGamblerModal/ProblemGamblerModal.module.scss'
import { IDocument } from '@Interfaces/CommonInterfaces'

interface Props {
  changeStep: any
  timeLoc: any
  doc: IDocument
}

const Step1: React.FC<Props> = ({ changeStep, timeLoc, doc }) => {
  const isImmediate = timeLoc === 'account__immediate'

  const renderTriggers = (triggers: any) => {
    if (isEmptyTriggersTitles(triggers)) {
      return null
    }

    let content = triggers.map((trigger: any, key: any) => {
      if (!trigger.title) {
        return null
      }

      return (
        <div key={key}>
          <b className={cls.triggerCommentTitle}>
            {trigger.title} {trigger.title_params}
          </b>
        </div>
      )
    })

    return <div className={cls.triggerComment}>{content}</div>
  }

  const isEmptyTriggersTitles = (triggers: any) => {
    for (let key in triggers) {
      if (triggers[key].title) {
        return false
      }
    }
    return true
  }

  const triggers = doc?.triggers

  return (
    <div className={`${cls.step} ${cls.first}`}>
      <div className={cls.modalHeader}>
        <div className={cls.title}>
          <p>{'How safe is your gambling?'}</p>
          <p>{isImmediate ? 'account__immediate_action_required' : timeLoc}</p>
        </div>
      </div>
      <div className={cls.text}>
        <p>
          One of CFD missions is to contribute and create a safe environment for its players where betting and games are
          used only for the purpose of entertainment. In this regard, CFD has implemented latest and best procedures to
          keep gaming environment safe as its entertaining.
        </p>
        {triggers ? renderTriggers(triggers) : null}
        <p>
          Both Gambling Commission and Malta Gaming Authority require us to inform you about responsible gaming controls
          we are offering to our customers. You may consider to define personal limits to adjust deposit amount, stake
          or lose over a time.
        </p>
        <p>
          To help us better understand whether any assistance is required, please answer a few questions using self
          assessment form. It should not take more than a few moments of your time.
        </p>
      </div>

      <div className={cls.modalFooter}>
        {isImmediate ? (
          <div className={cls.status}>
            <b>{'Temporary suspension was applied to your account'}</b>
          </div>
        ) : (
          <div className={cls.status}>
            {'Temporary suspension will be applied to your account in'} <b>{timeLoc}</b>
          </div>
        )}
        <button className={cls.button} onClick={() => changeStep(2)}>
          {'Continue'}
        </button>
      </div>
    </div>
  )
}

export default Step1
